module.exports = __webpack_public_path__ + "static/media/FL_BNobleM_pt.b2146e8c.png";